import { v4 as uuidv4 } from 'uuid'

const initialiseDataAnalyticsToken = async () => ({
  context: {
    dataAnalyticsToken: uuidv4(),
  },
})

export default initialiseDataAnalyticsToken
